export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";